import { getErrorMessageWithoutCode } from "../../errorLib";
import { formatDuration, formatSize } from "../../helpers";

export function handleRESTResponse(model, result) {
  const resultBody = result.body || result.obj;

  if (!resultBody) {
    throw new Error("Invalid response format from server");
  }

  if (resultBody.error) {
    // External error returned by the "REST proxy" service.
    model.response = {
      data: null,
      status: resultBody.error.status,
      statusText: resultBody.error.statusText || "Error",
      error: {
        message: resultBody.error.message,
        details: resultBody.error.description,
        code:
          resultBody.error.status ||
          resultBody.error.statusCode ||
          resultBody.error.code,
      },
    };
  } else if (resultBody.response) {
    const response = resultBody.response;
    model.response = {
      data: response.data,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      cookies: response.cookies || [],
      duration: formatDuration(response.duration || 0),
      size: formatSize(response.size || 0),
      contentType: response.contentType,
      isBinary: response.isBinary,
      fileExtension: response.fileExtension,
      filename: response.filename,
      error: null,
    };
  } else {
    throw new Error("Invalid response format from server");
  }
}

export function handleRESTError(model, error) {
  const errorResponse =
    error.response?.body?.result?.error || error.response || error;

  let parsedError;
  if (errorResponse?.text) {
    try {
      parsedError = JSON.parse(errorResponse.text);
    } catch (parseErr) {
      // Not JSON; leave parsedError undefined.
      console.error("Error parsing error response:", parseErr);
    }
  }

  const finalError = parsedError || errorResponse;

  model.response = {
    data: null,
    status: finalError?.status || error.status || 500,
    statusText:
      finalError?.statusText || error.statusText || "Internal Server Error",
    headers: finalError?.headers || {},
    cookies: [],
    duration: formatDuration(finalError?.duration || 0),
    size: formatSize(finalError?.size || 0),
    error: {
      message:
        finalError?.message ||
        getErrorMessageWithoutCode(error, "Request failed"),

      details:
        finalError?.description ||
        finalError?.details ||
        finalError?.stack ||
        error.message ||
        (typeof finalError === "string" ? finalError : ""),

      code:
        finalError?.status ||
        finalError?.statusCode ||
        error.status ||
        error.statusCode ||
        finalError?.code,
    },
  };
}
